import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
	gridContainer: {
		justifyContent: 'space-between',
		paddingBottom: 10,
		paddingTop: 10,
	},
});
